module.exports = __webpack_public_path__ + "static/Truck9-11640bab87f857491bdeec664c4b69ba.png";